@for (company of companies(); track company.companyId) {
  <a
    mat-menu-item
    class="qaroni-pn-500-15"
    tabindex="0"
    (click)="goToCompanyDetails(company)"
    (keypress)="goToCompanyDetails(company)"
    routerLinkActive="qaroni-text-primary">
    <mat-icon class="icon-menu">domain</mat-icon> {{ company?.name }}
  </a>
}
